// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - SDKProjectContext
/**
 * Represents a project context containing repository and technology information.
 */
export class SDKProjectContext {
    constructor(model) {
        this.id = model.id;
        this.name = model.name;
        this.description = model.description;
        this.designSystemId = model.designSystemId;
        this.dependencies = model.dependencies;
        this.npmProxyRegistry = model.npmProxyRegistry;
    }
    /**
     * Converts the context to a remote model for storage.
     */
    toRemote() {
        return {
            id: this.id,
            name: this.name,
            description: this.description,
            designSystemId: this.designSystemId,
            dependencies: this.dependencies,
            npmProxyRegistry: this.npmProxyRegistry,
        };
    }
    /**
     * Converts the context to a transport model for serialization.
     */
    toTransport() {
        return {
            id: this.id,
            name: this.name,
            description: this.description,
            designSystemId: this.designSystemId,
            dependencies: this.dependencies,
            npmProxyRegistry: this.npmProxyRegistry,
        };
    }
    /**
     * Creates an instance from a transport model.
     */
    static fromTransport(model) {
        return new SDKProjectContext(model);
    }
}
